import React, { useEffect, useState } from "react";
import api from "../../../core/axios/axiosInstance";

const PipedriveCallback = () => {
  const [status, setStatus] = useState("processing");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    if (!code) {
      setStatus("error");
      if (window.opener) {
        window.opener.postMessage({ status: "error", message: "No authorization code received" }, "*");
        window.close();
      }
      return;
    }

    api
      .post("api/pipedrive/exchange-code", { code })
      .then((response) => {
        setStatus("success");
        if (window.opener) {
          window.opener.postMessage(response.data, "*");
          window.close();
        }
      })
      .catch((err) => {
        setStatus("error");
        const message = err?.response?.data?.message || "Pipedrive OAuth failed";
        if (window.opener) {
          window.opener.postMessage({ status: "error", message }, "*");
          window.close();
        }
      });
  }, []);

  return (
    <div style={{ fontFamily: "Arial, sans-serif", textAlign: "center", paddingTop: "50px" }}>
      {status === "processing" && <p>Connecting Pipedrive...</p>}
      {status === "success" && (
        <p style={{ color: "green", fontSize: "18px" }}>
          Pipedrive connected successfully! You can close this window.
        </p>
      )}
      {status === "error" && (
        <p style={{ color: "red", fontSize: "18px" }}>
          Connection failed. Please close this window and try again.
        </p>
      )}
    </div>
  );
};

export default PipedriveCallback;
